var _defs, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketThruster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 40",
    width: 72,
    height: 40,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flame",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-accent,#37E5FF)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-primary,#7C4DFF)"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .body { fill: #fff; opacity:.95 }\n      .tip { fill: var(--color-primary,#7C4DFF) }\n      .flame { fill: url(#flame); transform-origin: 18px 20px; animation: flicker .18s ease-in-out infinite alternate; filter: drop-shadow(0 0 6px rgba(124,77,255,.7)); }\n      @keyframes flicker { from { transform: scaleX(.9) } to { transform: scaleX(1.05) } }\n      @media (prefers-reduced-motion: reduce) { .flame { animation: none } }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "body",
    d: "M28 10h20a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H28l-8 4v-28l8 4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "tip",
    x: 48,
    y: 16,
    width: 8,
    height: 12,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "flame",
    d: "M18 20c-8 0-10 6-10 6s2-2 4-1c-4 6 4 10 6 6 2 4 10 0 6-6 2-1 4 1 4 1s-2-6-10-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketThruster);
export default __webpack_public_path__ + "static/media/rocket-thruster.21ebd0279e6d319e041966b7aece289d.svg";
export { ForwardRef as ReactComponent };